export const insuranceFormParametersGeneration = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  clientPreferences,
  action = 'save',
}) => {
  const options = new URLSearchParams()

  const ensureCorrectCommissionFormat = value => {
    return value.replace(',', '.')
  }

  options.append('type', type || '')
  options.append('id', contractId || '')
  options.append('contact_id', contactId || '')
  options.append('address_id', addressId || '')
  options.append('action', action)

  options.append('prestation_type', characteristicsData.prestationType || '')
  options.append('product_type', characteristicsData.productType || '')

  options.append('offer_id', contractData.offerId ? parseInt(contractData.offerId) : '')
  options.append('organisation_id', contractData.providerId ? parseInt(contractData.providerId) : '')
  if (contractData.providerExternalId) {
    options.append('provider_external_id', contractData.providerExternalId)
  }
  if (contractData.annualPremium && contractData.annualPremium.length > 0) {
    options.append('annual_premium', ensureCorrectCommissionFormat(contractData.annualPremium))
  }
  if (contractData.annualCommission && contractData.annualCommission.length > 0) {
    options.append('annual_commission', ensureCorrectCommissionFormat(contractData.annualCommission))
  }
  if (contractData.fees?.length > 0) {
    options.append('fees', ensureCorrectCommissionFormat(contractData.fees))
  }

  if (clientPreferences.createEkomiInteraction) {
    options.append('create_ekomi_interaction', clientPreferences.createEkomiInteraction ? '1' : '0')
  }

  if (contractData.businessCard !== undefined) {
    options.append('business_card', contractData.businessCard === 1 ? '1' : '0')
  }

  return options
}
